import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "content" }
const _hoisted_2 = { id: "slider" }
const _hoisted_3 = { class: "container py-5 py-lg-6" }
const _hoisted_4 = { class: "row align-items-center justify-content-between" }
const _hoisted_5 = { class: "col-xl-6 col-lg-7 pt-lg-5 pb-lg-6 ps-5" }
const _hoisted_6 = { class: "position-relative z-1" }
const _hoisted_7 = { class: "display-4 mb-4" }
const _hoisted_8 = { class: "section bg-color bg-opacity-10 my-0" }
const _hoisted_9 = { class: "container py-5" }
const _hoisted_10 = { class: "row col-mb-50 posts-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArticlePreview = _resolveComponent("ArticlePreview")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "position-absolute end-0 bootom-0 w-100 h-100 hero-img",
          style: {"background":"url('/demos/mj/cc_home_banner.png') no-repeat bottom / auto 100%","min-height":"500px"}
        }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "fs-6 text-uppercase ls-3 mb-4" }, null, -1)),
                _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.appConfigs.general.metadata.home), 1),
                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "fs-6 mt-3 fw-normal title-text" }, " Join our multiplayer live Crossword Arena. Compete against other players to solve 5x5 crosswords and climb the leaderboard. ", -1))
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mt-4 mb-5" }, [
                _createElementVNode("a", {
                  href: "/crossword/live",
                  class: "button h-text-light border border-width-2 border-dark rounded button-shadow button-shadow-dark"
                }, " Play Now "),
                _createElementVNode("a", {
                  href: "/about",
                  class: "button text-dark h-text-dark border border-width-2 border-dark rounded button-shadow button-shadow-dark",
                  style: {"background-color":"white"}
                }, " About ")
              ], -1))
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-lg-5" }, null, -1))
          ])
        ])
      ])
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", {
      class: "section py-lg-6",
      style: {"background":"linear-gradient(to bottom, var(--cnvs-themecolor) 60%, #FFF 60%)","margin":"12rem 0 8rem 0"}
    }, [
      _createElementVNode("div", {
        class: "container dark",
        "data-bs-theme": "dark"
      }, [
        _createElementVNode("div", { class: "row align-items-end mb-5 justify-content-between" }, [
          _createElementVNode("div", { class: "col-12 px-4" }, [
            _createElementVNode("h2", { class: "mb-0 display-4 fw-bold" }, [
              _createTextVNode("Explore Our Puzzle Collection"),
              _createElementVNode("br"),
              _createTextVNode(),
              _createElementVNode("span", { class: "font-secondary fw-light fst-italic text-white display-4" }, "Solve"),
              _createElementVNode("small", { class: "mx-3 op-03" }, "·"),
              _createElementVNode("span", { class: "font-secondary fw-light fst-italic text-white display-4" }, "Create"),
              _createElementVNode("small", { class: "mx-3 op-03" }, "·"),
              _createElementVNode("span", { class: "font-secondary fw-light fst-italic text-white display-4" }, "Share")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", { class: "slider-element section-podcasts overflow-visible" }, [
        _createElementVNode("div", { class: "container-fluid" }, [
          _createElementVNode("div", { class: "swiper_wrapper customjs overflow-visible h-auto" }, [
            _createElementVNode("div", { class: "swiper swiper-parent overflow-visible swiper-initialized swiper-horizontal swiper-backface-hidden" }, [
              _createElementVNode("div", {
                class: "swiper-wrapper",
                id: "swiper-wrapper-e072d86d430a899c",
                "aria-live": "polite",
                style: {"cursor":"grab","transition-duration":"0ms","transform":"translate3d(0px, 0px, 0px)","transition-delay":"0ms"}
              }, [
                _createElementVNode("div", {
                  class: "swiper-slide swiper-slide-active",
                  role: "group",
                  "aria-label": "1 / 6",
                  style: {"width":"374.5px","margin-right":"40px"},
                  "data-swiper-slide-index": "0"
                }, [
                  _createElementVNode("div", { class: "d-flex flex-column p-4 rounded-3 shadow-lg feature-slider-bg" }, [
                    _createElementVNode("h3", { class: "mb-3" }, " Live Arena "),
                    _createElementVNode("img", {
                      g: "",
                      src: "/demos/mj/cc_gameplay.png",
                      alt: "Gameplay",
                      class: "mb-5"
                    }),
                    _createElementVNode("p", { class: "text-muted mb-0 feature-slider-text" }, [
                      _createElementVNode("strong", { class: "font-secondary" }, " Race against other players in the Live Arena"),
                      _createTextVNode(" - there's always a game waiting for you. ")
                    ]),
                    _createElementVNode("a", {
                      href: "/crossword/live",
                      target: "_blank",
                      class: "button h-text-light border border-width-2 border-dark rounded button-shadow button-shadow-dark"
                    }, " Play Now ")
                  ])
                ]),
                _createElementVNode("div", {
                  class: "swiper-slide swiper-slide-active",
                  role: "group",
                  "aria-label": "2 / 6",
                  style: {"width":"374.5px","margin-right":"40px"},
                  "data-swiper-slide-index": "0"
                }, [
                  _createElementVNode("div", { class: "d-flex flex-column p-4 rounded-3 shadow-lg feature-slider-bg" }, [
                    _createElementVNode("h3", { class: "mb-3" }, " Daily Puzzles "),
                    _createElementVNode("img", {
                      g: "",
                      src: "/demos/mj/cc_daily_puzzle_gameplay.png",
                      alt: "Gameplay",
                      class: "mb-5"
                    }),
                    _createElementVNode("p", { class: "text-muted mb-0 feature-slider-text" }, [
                      _createElementVNode("strong", { class: "font-secondary" }, "Check out our daily mini puzzle"),
                      _createTextVNode(" and race solve the in the fastest time. ")
                    ]),
                    _createElementVNode("a", {
                      href: "/crossword/daily",
                      target: "_blank",
                      class: "button h-text-light border border-width-2 border-dark rounded button-shadow button-shadow-dark"
                    }, " Play Now ")
                  ])
                ]),
                _createElementVNode("div", {
                  class: "swiper-slide swiper-slide-active",
                  role: "group",
                  "aria-label": "3 / 6",
                  style: {"width":"374.5px","margin-right":"40px"},
                  "data-swiper-slide-index": "0"
                }, [
                  _createElementVNode("div", { class: "d-flex flex-column p-4 rounded-3 shadow-lg feature-slider-bg" }, [
                    _createElementVNode("h3", { class: "mb-3" }, " Community Puzzles "),
                    _createElementVNode("img", {
                      g: "",
                      src: "/demos/mj/cc_community_puzzle_gameplay.png",
                      alt: "Gameplay",
                      class: "mb-5"
                    }),
                    _createElementVNode("p", { class: "text-muted mb-0 feature-slider-text" }, [
                      _createElementVNode("strong", { class: "font-secondary" }, "Browse our library of free puzzles"),
                      _createTextVNode(" to solve, play, and share puzzles created by our community. ")
                    ]),
                    _createElementVNode("a", {
                      href: "/crossword/create/browse",
                      target: "_blank",
                      class: "button h-text-light border border-width-2 border-dark rounded button-shadow button-shadow-dark"
                    }, " Play Now ")
                  ])
                ]),
                _createElementVNode("div", {
                  class: "swiper-slide swiper-slide-active",
                  role: "group",
                  "aria-label": "4 / 6",
                  style: {"width":"374.5px","margin-right":"40px"},
                  "data-swiper-slide-index": "0"
                }, [
                  _createElementVNode("div", { class: "d-flex flex-column p-4 rounded-3 shadow-lg feature-slider-bg" }, [
                    _createElementVNode("h3", { class: "mb-3" }, " Mini Crossword Creator "),
                    _createElementVNode("img", {
                      g: "",
                      src: "/demos/mj/cc_crossword_creator_gameplay.png",
                      alt: "Gameplay",
                      class: "mb-5"
                    }),
                    _createElementVNode("p", { class: "text-muted mb-0 feature-slider-text" }, [
                      _createElementVNode("strong", { class: "font-secondary" }, "Create and share you own puzzles"),
                      _createTextVNode(" directly in the browser using our free Crossword Creator tool. ")
                    ]),
                    _createElementVNode("a", {
                      href: "/crossword/create",
                      target: "_blank",
                      class: "button h-text-light border border-width-2 border-dark rounded button-shadow button-shadow-dark"
                    }, " Create Puzzles ")
                  ])
                ]),
                _createElementVNode("div", {
                  class: "swiper-slide swiper-slide-active",
                  role: "group",
                  "aria-label": "5 / 6",
                  style: {"width":"374.5px","margin-right":"40px"},
                  "data-swiper-slide-index": "0"
                }, [
                  _createElementVNode("div", { class: "d-flex flex-column p-4 rounded-3 shadow-lg feature-slider-bg" }, [
                    _createElementVNode("h3", { class: "mb-3" }, " Crossword Upload "),
                    _createElementVNode("img", {
                      g: "",
                      src: "/demos/mj/cc_upload_gameplay.png",
                      alt: "Gameplay",
                      class: "mb-5"
                    }),
                    _createElementVNode("p", { class: "text-muted mb-0 feature-slider-text" }, [
                      _createElementVNode("strong", { class: "font-secondary" }, "Upload and play .ipuz files"),
                      _createTextVNode(" directly in your browser with our free Crossword Upload tool—no account required. ")
                    ]),
                    _createElementVNode("a", {
                      href: "/crossword/upload",
                      target: "_blank",
                      class: "button h-text-light border border-width-2 border-dark rounded button-shadow button-shadow-dark"
                    }, " Play Now ")
                  ])
                ]),
                _createElementVNode("div", {
                  class: "swiper-slide swiper-slide-active",
                  role: "group",
                  "aria-label": "6 / 6",
                  style: {"width":"374.5px","margin-right":"40px"},
                  "data-swiper-slide-index": "0"
                }, [
                  _createElementVNode("div", { class: "d-flex flex-column p-4 rounded-3 shadow-lg feature-slider-bg" }, [
                    _createElementVNode("h3", { class: "mb-3" }, " Community Forum "),
                    _createElementVNode("img", {
                      g: "",
                      src: "/demos/mj/cc_community_forum_gameplay.png",
                      alt: "Gameplay",
                      class: "mb-5"
                    }),
                    _createElementVNode("p", { class: "text-muted mb-0 feature-slider-text" }, [
                      _createElementVNode("strong", { class: "font-secondary" }, "Engage with other players"),
                      _createTextVNode(" in the community forum. ")
                    ]),
                    _createElementVNode("a", {
                      href: "/community/posts",
                      target: "_blank",
                      class: "button h-text-light border border-width-2 border-dark rounded button-shadow button-shadow-dark"
                    }, " Play Now ")
                  ])
                ])
              ]),
              _createElementVNode("span", {
                class: "swiper-notification",
                "aria-live": "assertive",
                "aria-atomic": "true"
              })
            ]),
            _createElementVNode("div", { class: "swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal" }, [
              _createElementVNode("span", {
                class: "swiper-pagination-bullet swiper-pagination-bullet-active",
                tabindex: "0",
                "aria-current": "true"
              }),
              _createElementVNode("span", {
                class: "swiper-pagination-bullet",
                tabindex: "0"
              }),
              _createElementVNode("span", {
                class: "swiper-pagination-bullet",
                tabindex: "0"
              }),
              _createElementVNode("span", {
                class: "swiper-pagination-bullet",
                tabindex: "0"
              }),
              _createElementVNode("span", {
                class: "swiper-pagination-bullet",
                tabindex: "0"
              })
            ])
          ])
        ])
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row justify-content-center mb-4" }, [
          _createElementVNode("div", { class: "col-md-6 text-center" }, [
            _createElementVNode("p", { class: "color text-uppercase ls-3 small mb-3" }, "Blog"),
            _createElementVNode("h3", { class: "display-5 mb-5" }, "Our Latest Posts")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts.slice(0, 3), (post) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-lg-4 entry mb-0",
              key: post.id
            }, [
              _createVNode(_component_ArticlePreview, { post: post }, null, 8, ["post"])
            ]))
          }), 128))
        ])
      ])
    ]),
    _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"section bg-transparent my-0 py-0\" data-v-0cb80c87><div class=\"container-fluid py-6\" data-v-0cb80c87><div class=\"row justify-content-center mx-auto mw-md gx-5\" data-v-0cb80c87><div class=\"col\" data-v-0cb80c87><p class=\"h6 mb-0\" data-v-0cb80c87> This site and its community are designed for entertainment and engagement. While we strive for accuracy in our puzzles and content, occasional errors may occur, and community contributions reflect individual opinions, not the views of the site. If you have inquiries, wish to rectify misinformation, or seek clarification about our community, feel free to <a href=\"/about#contact\" data-v-0cb80c87>Contact Us</a>. </p></div></div></div></div>", 1))
  ], 64))
}